import { render, staticRenderFns } from "./create-subtask.component.vue?vue&type=template&id=782aa0de&scoped=true"
import script from "./create-subtask.component.vue?vue&type=script&lang=js"
export * from "./create-subtask.component.vue?vue&type=script&lang=js"
import style0 from "./create-subtask.component.vue?vue&type=style&index=0&id=782aa0de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782aa0de",
  null
  
)

export default component.exports